export enum SAT_UNIT_CATEGORY {
  READING = 'Reading & Writing',
  MATH = 'Math',
}
